<template>
  <div class="row">
    <div :class="[validatedSectionClass, generalClass]" class="col-md-12">
        <!-- gender.length <= 4 -->
        <div v-if="this.$store.state.gender.length <= 4 && this.$store.state.requirements['gender']">
          <div class="row mt-5">
            <div class="col-md-2 col-md-offset-1">
              <div class="form-group">
                <label
                    class="control-label"
                    :class="modelValidations.gender['required'] ? 'required' : ''"
                    for="gender"
                >
                {{computeReportableCaption(this.$store.state.requirements['gender']['reportable_name'], this.fields_en['gender'], this.$store.state.lang.value.toLowerCase())}}
                </label><br>
                <div class="default-grey font-small" v-show="getFieldDescription('gender')" v-html="getFieldDescription('gender') || ''">
                </div>
              </div>
            </div>
            <div class="col-md-8 gender-float">
                <div class="form-group">
                    <el-radio-group
                        size="small"
                        data-vv-as="Gender"
                        id="gender"
                        v-validate="modelValidations.gender"
                        placeholder="Single Select"
                        name="gender"
                        v-model="model.gender"
                    >
                        <el-radio-button
                        v-for="option in this.$store.state.gender"
                        :value="option.name"
                        :label="option.name"
                        :key="option.name"
                        tabindex="0"
                        >{{computeCaption(option.name, $store.state.lang.value.toLowerCase())}}
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="col-md-10 col-md-offset-1">
                <div class="form-group">
                    <small class="text-danger col-md-0" v-show="gender.invalid">
                      {{computeCaption(getError("gender"), this.$store.state.lang.value.toLowerCase())}}
                    </small>
                </div>
            </div>
            </div>
        </div>
        <!-- dob -->
        <div v-if="(this.$store.state.requirements['gender'] === undefined || this.$store.state.requirements['gender'] === '') || (this.$store.state.gender.length <= 4 && this.$store.state.requirements['gender'])" class="row">
           <div class="col-md-10 col-md-offset-1">
              <div class="form-group">
                <label class="control-label required" for="dob">
                  {{computeReportableCaption(this.$store.state.requirements['date_of_birth']['reportable_name'], this.fields_en['date_of_birth'], this.$store.state.lang.value.toLowerCase())}}
                </label>
                <input
                  class="form-control date-cleave-format"
                  type="text"
                  id="dob"
                  name="dob_pretty"
                  v-model="model.dob_pretty"
                  v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                  @change="validateDate($event.target.value)"
                  placeholder="ex: 12/22/1980"
                  maxlength="10"
                />
                <div class="default-grey font-small" v-show="getFieldDescription('date_of_birth')" v-html="getFieldDescription('date_of_birth') || ''"></div>
                <small class="text-danger" v-if="errorDate" v-text="computeCaption(errorDate, this.$store.state.lang.value.toLowerCase())">
                  {{computeCaption(errorDate, this.$store.state.lang.value.toLowerCase())}}
                </small>
                <small class="text-danger" v-if="error_date" v-text="computeCaption(error_date, this.$store.state.lang.value.toLowerCase())">
                  {{computeCaption(error_date, this.$store.state.lang.value.toLowerCase())}}
                </small>
              </div>
            </div>
        </div>
        <!-- gender.length > 4 & dob-->
        <div v-if="this.$store.state.gender.length > 4 && this.$store.state.requirements['gender']" class="row">
            <!-- Gender -->
            <div class="col-md-5 col-md-offset-1">
                <div class="form-group">
                    <label
                        class="control-label"
                        :class="modelValidations.gender['required'] ? 'required' : ''"
                        for="gender"
                    >
                    {{computeReportableCaption(this.$store.state.requirements['gender']['reportable_name'], this.fields_en['gender'], this.$store.state.lang.value.toLowerCase())}}
                    </label>
                    <el-select
                        size="large"
                        id="gender1"
                        data-vv-as="Gender"
                        v-validate="modelValidations.gender"
                        placeholder="Single Select"
                        name="gender"
                        v-model="model.gender"
                    >
                        <el-option
                        v-for="option in this.$store.state.gender"
                        class="select-danger"
                        :value="option.name"
                        :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                        :key="option.name"
                        >
                        </el-option>
                    </el-select>
                    <div class="default-grey font-small" v-show="getFieldDescription('gender')" v-html="getFieldDescription('gender') || ''"></div>
                    <small class="text-danger" v-show="gender.invalid">
                    {{computeCaption(getError("gender"), this.$store.state.lang.value.toLowerCase())}}
                    </small>
                </div>
            </div>
            <!-- dob -->
            <div class="col-md-5">
              <div class="form-group">
                <label class="control-label required" for="dob">
                  {{computeReportableCaption(this.$store.state.requirements['date_of_birth']['reportable_name'], this.fields_en['date_of_birth'], this.$store.state.lang.value.toLowerCase())}}
                </label>
                <input
                  class="form-control date-cleave-format"
                  type="text"
                  id="dob"
                  name="dob_pretty"
                  v-model="model.dob_pretty"
                  v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                  @change="validateDate($event.target.value)"
                  placeholder="ex: 12/22/1980"
                  maxlength="10"
                />
                <div class="default-grey font-small" v-show="getFieldDescription('date_of_birth')" v-html="getFieldDescription('date_of_birth') || ''"></div>
                <small class="text-danger" v-if="errorDate" v-text="computeCaption(errorDate, this.$store.state.lang.value.toLowerCase())">
                  {{computeCaption(errorDate, this.$store.state.lang.value.toLowerCase())}}
                </small>
                <small class="text-danger" v-if="error_date" v-text="computeCaption(error_date, this.$store.state.lang.value.toLowerCase())">
                  {{computeCaption(error_date, this.$store.state.lang.value.toLowerCase())}}
                </small>
              </div>
            </div>
          </div>
            <!-- guardian data -->
            <div v-if="type === 'Registration' || type === undefined || type === 'dependentRegistration' || type === 'dependentUpdate'">
                <div v-if="guardian_info" class="row">
                <div class="col-md-5 col-md-offset-1">
                  <div class="form-group">
                    <label class="control-label required">
                    {{computeCaption (this.fields_en['guardian_first_name'], this.$store.state.lang.value.toLowerCase())}}
                    </label>
                    <input
                      class="form-control"
                      type="text"
                      data-vv-as="Guardian's First Name"
                      name="guardianFirstName"
                      v-validate="modelValidations.guardianFirstName"
                      v-model="model.guardianFirstName"
                      placeholder="ex: Mike"
                      :disabled="model.guardianFirstName !== '' && (type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected))"
                      onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                    />
                    <div class="default-grey font-small" v-show="getFieldDescription('guardian_first_name')" v-html="getFieldDescription('guardian_first_name') || ''"></div>
                    <small class="text-danger" v-show="guardianFirstName.invalid">
                      {{computeCaption(getError("guardianFirstName", "First"), this.$store.state.lang.value.toLowerCase())}}
                    </small>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group">
                    <label class="control-label required">
                    {{computeCaption (this.fields_en['guardian_last_name'], this.$store.state.lang.value.toLowerCase())}}
                    </label>
                    <input
                      class="form-control"
                      type="text"
                      data-vv-as="Guardian's Last Name"
                      name="guardianLastName"
                      v-validate="modelValidations.guardianLastName"
                      v-model="model.guardianLastName"
                      placeholder="ex: Andrew"
                      :disabled="model.guardianLastName !== '' && (type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected))"
                      onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                    />
                    <div class="default-grey font-small" v-show="getFieldDescription('guardian_last_name')" v-html="getFieldDescription('guardian_last_name') || ''"></div>
                    <small class="text-danger" v-show="guardianLastName.invalid">
                      {{computeCaption(getError("guardianLastName"), this.$store.state.lang.value.toLowerCase())}}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row" v-if="guardian_info">
                <div class="col-md-10 col-md-offset-1">
                  <div class="form-group">
                    <label class="control-label required">
                    {{computeCaption (this.fields_en['guardian_date_of_birth'], this.$store.state.lang.value.toLowerCase())}}
                    </label>
                    <input
                      class="form-control date-cleave-format1"
                      type="text"
                      name="guardian_dob_pretty"
                      v-model="model.guardian_dob_pretty"
                      v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                      @change="validateDateGuardian($event.target.value)"
                      placeholder="ex: 12/22/1980"
                      maxlength="10"
                      :disabled="model.guardian_dob_pretty !== '' && (type === 'dependentRegistration' || type === 'dependentUpdate' || (type === 'Registration' && $store.state.dependentSelected))"
                    />
                    <div class="default-grey font-small" v-show="getFieldDescription('guardian_dob')" v-html="getFieldDescription('guardian_dob') || ''"></div>
                    <small
                      class="text-danger"
                      v-if="error_guardian_dob"
                      v-text="computeCaption(error_guardian_dob, this.$store.state.lang.value.toLowerCase())"
                    >
                    {{computeCaption(errorDate, this.$store.state.lang.value.toLowerCase())}}
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <!-- race & ethnicity -->
            <div v-if="this.$store.state.requirements['ethnicity'] && this.$store.state.requirements['race']" class="row">
              <!-- race -->
              <div class="col-md-5 col-md-offset-1">
                <div class="form-group">
                    <label
                        class="control-label"
                        :class="modelValidations.race['required'] ? 'required' : ''"
                        for="race"
                    >
                    {{computeCaption(this.fields_en['race'], this.$store.state.lang.value.toLowerCase())}}
                    </label>
                    <el-select
                        size="large"
                        id="race"
                        data-vv-as="Race"
                        v-validate="modelValidations.race"
                        placeholder="Single Select"
                        name="race"
                        v-model="model.race"
                    >
                        <el-option
                        v-for="option in this.$store.state.race"
                        class="select-danger"
                        :value="option.name"
                        :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                        :key="option.name"
                        >
                        </el-option>
                    </el-select>
                    <div class="default-grey font-small" v-show="getFieldDescription('race')" v-html="getFieldDescription('race') || ''"></div>
                    <small class="text-danger" v-show="race.invalid">
                    {{computeCaption(getError("race"), this.$store.state.lang.value.toLowerCase())}}
                    </small>
                </div>
              </div>
              <!-- ethnicity -->
              <div class="col-md-5">
                <div class="form-group">
                  <label
                    class="control-label"
                    :class="modelValidations.ethnicity['required'] ? 'required' : ''"
                    for="ethnicity"
                  >
                    {{computeReportableCaption(this.$store.state.requirements['ethnicity']['reportable_name'], this.fields_en['ethnicity'], this.$store.state.lang.value.toLowerCase())}}
                  </label>
                  <el-select
                    size="large"
                    id="ethnicity"
                    data-vv-as="Ethnicity"
                    v-validate="modelValidations.ethnicity"
                    placeholder="Single Select"
                    name="ethnicity"
                    v-model="model.ethnicity"
                  >
                    <el-option
                      v-for="option in this.$store.state.ethnicity"
                      class="select-danger"
                      :value="option.name"
                      :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                      :key="option.name"
                    >
                    </el-option>
                  </el-select>
                  <div class="default-grey font-small" v-show="getFieldDescription('ethnicity')" v-html="getFieldDescription('ethnicity') || ''"></div>
                  <small class="text-danger" v-show="ethnicity.invalid">
                    {{computeCaption(getError("ethnicity"), this.$store.state.lang.value.toLowerCase())}}
                  </small>
                </div>
              </div>
            </div>
            <!-- only race -->
            <div v-if="(this.$store.state.requirements['ethnicity'] === undefined || this.$store.state.requirements['ethnicity'] === '') && this.$store.state.requirements['race']" class="row">
              <div class="col-md-10 col-md-offset-1">
                <div class="form-group">
                    <label
                        class="control-label"
                        :class="modelValidations.race['required'] ? 'required' : ''"
                        for="race"
                    >
                    {{computeCaption(this.fields_en['race'], this.$store.state.lang.value.toLowerCase())}}
                    </label>
                    <el-select
                        size="large"
                        id="race"
                        data-vv-as="Race"
                        v-validate="modelValidations.race"
                        placeholder="Single Select"
                        name="race"
                        v-model="model.race"
                    >
                        <el-option
                        v-for="option in this.$store.state.race"
                        class="select-danger"
                        :value="option.name"
                        :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                        :key="option.name"
                        >
                        </el-option>
                    </el-select>
                    <div class="default-grey font-small" v-show="getFieldDescription('race')" v-html="getFieldDescription('race') || ''"></div>
                    <small class="text-danger" v-show="race.invalid">
                    {{computeCaption(getError("race"), this.$store.state.lang.value.toLowerCase())}}
                    </small>
                </div>
              </div>
            </div>
            <!-- only ethnicity -->
            <div v-if="this.$store.state.requirements['ethnicity'] && (this.$store.state.requirements['race'] === undefined || this.$store.state.requirements['race'] === '')" class="row">
               <div class="col-md-10 col-md-offset-1">
                <div class="form-group">
                  <label
                    class="control-label"
                    :class="modelValidations.ethnicity['required'] ? 'required' : ''"
                    for="ethnicity"
                  >
                    {{computeReportableCaption(this.$store.state.requirements['ethnicity']['reportable_name'], this.fields_en['ethnicity'], this.$store.state.lang.value.toLowerCase())}}
                  </label>
                  <el-select
                    size="large"
                    id="ethnicity"
                    data-vv-as="Ethnicity"
                    v-validate="modelValidations.ethnicity"
                    placeholder="Single Select"
                    name="ethnicity"
                    v-model="model.ethnicity"
                  >
                    <el-option
                      v-for="option in this.$store.state.ethnicity"
                      class="select-danger"
                      :value="option.name"
                      :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                      :key="option.name"
                    >
                    </el-option>
                  </el-select>
                  <div class="default-grey font-small" v-show="getFieldDescription('ethnicity')" v-html="getFieldDescription('ethnicity') || ''"></div>
                  <small class="text-danger" v-show="ethnicity.invalid">
                    {{computeCaption(getError("ethnicity"), this.$store.state.lang.value.toLowerCase())}}
                  </small>
                </div>
              </div>
            </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vee-validate'
import Cleave from 'cleave.js'
import {ValidationUtils} from '../../../../utils/Validation'
import {FormatterUtils} from '../../../../utils/Formatter.js'
import {RadioButton, RadioGroup} from 'element-ui'
import {TranslationsUtils} from '../../../../utils/Translations.js'
import {SettingsUtils} from '../../../../utils/SiteConfigurations'
import {AccessionUtils} from '../../../../utils/AccessionDetailsProcessing'
export default {
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils, AccessionUtils],
  props: ['type', 'triggerGeneticsWatch', 'configuration'],
  components: {
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup
  },
  data () {
    return {
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      geneticsSectionValidation: {
        genderValidation: !this.checkRequirement('gender'),
        raceValidation: !this.checkRequirement('race'),
        ethnicityValidation: !this.checkRequirement('ethnicity'),
        dobValidation: false,
        guardianFirstNameValidation: true,
        guardianLastNameValidation: true,
        guardianDobValidation: true
      },
      errorDate: '',
      error_date: '',
      error_guardian_dob: '',
      guardian_info: false,
      fields_en: {
        guardian_last_name: "Guardian's Last Name",
        guardian_first_name: "Guardian's First Name",
        guardian_date_of_birth: "Guardian's Date Of Birth",
        ethnicity: 'Ethnicity',
        gender: 'Gender',
        race: 'Race',
        date_of_birth: 'Date Of Birth'
      },
      model: {
        dob: '',
        dob_pretty: '',
        guardian_dob: (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') ? this.$store.state.patientRegistrationData['date_of_birth'] : '',
        guardian_dob_pretty: '',
        guardianLastName: (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') ? this.$store.state.patientRegistrationData['last_name'] : '',
        guardianFirstName: (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') ? this.$store.state.patientRegistrationData['first_name'] : '',
        gender: '',
        race: '',
        ethnicity: ''
      },
      modelValidations: {
        gender: {
          required: this.checkRequirement('gender')
        },
        race: {
          required: this.checkRequirement('race')
        },
        ethnicity: {
          required: this.checkRequirement('ethnicity')
        },
        guardianFirstName: {
          min: 2,
          required: true
        },
        guardianLastName: {
          min: 2,
          required: true
        }
      }
    }
  },
  methods: {
    computeGeneticsValidationObject () {
      if (Object.values(this.geneticsSectionValidation).every(field => field === true)) {
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validateDOB () {
      if (!this.model.dob) {
        this.errorDate = 'Date Of Birth field is required'
      } else if (this.isFutureDate(this.model.dob_pretty)) {
        this.errorDate = 'Date Of Birth should not be in the future'
      } else if (this.isOldDate(this.model.dob_pretty)) {
        this.errorDate = 'Date Of Birth should not be more than 120 years in the past'
      } else if (!this.errorDate.includes('must be valid')) {
        this.errorDate = ''
      }
    },
    validateGuardianDOB () {
      if (this.model.guardian_dob_pretty.length < 10) {
        this.error_guardian_dob = 'Date Of Birth field is required'
      } else if (this.isFutureDate(this.model.guardian_dob_pretty)) {
        this.error_guardian_dob = 'Date Of Birth should not be in the future'
      } else if (this.isOldDate(this.model.guardian_dob_pretty)) {
        this.error_guardian_dob = 'Date Of Birth should not be more than 120 years in the past'
      } else if (this.guardian_info) {
        let date1 = new Date(this.model.guardian_dob_pretty)
        var ageDifMs = Date.now() - date1
        var ageDate = new Date(ageDifMs)
        let ages = (Math.abs(ageDate.getUTCFullYear() - 1970))
        if (ages < 18) {
          this.error_guardian_dob = 'The age of the guardian must not be less than 18'
        } else {
          this.error_guardian_dob = ''
        }
      } else if (!this.errorDate.includes('must be valid')) {
        this.error_guardian_dob = ''
      }
      if (this.error_guardian_dob === '') {
        this.geneticsSectionValidation.guardianDobValidation = true
      } else {
        this.geneticsSectionValidation.guardianDobValidation = false
      }
    },
    async validate () {
      this.$store.state.medDataValidator = false
      await this.$validator.validateAll()
      this.validateDOB()
      if (this.guardian_info) {
        this.validateGuardianDOB()
      }
      if (this.$validator.errors.items.length && (this.$validator.errors.items[0].field === 'gender' || this.$validator.errors.items[0].field === 'ethnicity' || this.$validator.errors.items[0].field === 'dob' || this.$validator.errors.items[0].field === 'race')) {
        if (this.$validator.errors.items[0].field !== 'gender') {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        } else {
          if (this.$store.state.gender.length > 4) {
            document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          } else {
            document.getElementsByName(this.$validator.errors.items[0].field)[0].childNodes[0].focus()
          }
        }
      }
      if (!this.model.dob) {
        this.errorDate = 'Date Of Birth field is required'
      } else if (this.isFutureDate(this.model.dob_pretty)) {
        this.errorDate = 'Date Of Birth should not be in the future'
      } else if (this.isOldDate(this.model.dob_pretty)) {
        this.errorDate = 'Date Of Birth should not be more than 120 years in the past'
      } else if (!this.errorDate.includes('must be valid')) {
        this.errorDate = ''
      }
      if (this.model.dob_pretty && this.errorDate === '') {
        if (this.type === 'personalData' || (this.type === undefined && this.$store.state.configs.ENABLE_GUARDIAN_INFO === false)) {
          let date1 = new Date(this.model.dob_pretty)
          var ageDifMs = Date.now() - date1
          var ageDate = new Date(ageDifMs)
          let ages = (Math.abs(ageDate.getUTCFullYear() - 1970))
          if (ages < 18) {
            this.error_date = 'The age must not be less than 18'
            this.geneticsSectionValidation.dobValidation = false
          } else {
            this.error_date = ''
            this.geneticsSectionValidation.dobValidation = true
          }
        }
      }
      if (this.errorDate) {
        let flag = true
        for (let iterator in this.$validator.errors.items) {
          if (this.$validator.errors.items[iterator].field === 'lastName' || this.$validator.errors.items[iterator].field === 'firstName' || this.$validator.errors.items[iterator].field === 'gender') {
            flag = false
          }
        }
        if (flag === true) {
          document.getElementsByName('dob_pretty')[0].focus()
        }
      }
      if ((await this.$validator.validateAll() === true) && this.errorDate === '' && this.error_date === '' && this.error_guardian_dob === '') {
        this.configuration.model.dob = this.model.dob
        this.configuration.model.dob_pretty = this.model.dob_pretty
        this.configuration.model.guardian_dob = this.model.guardian_dob
        this.configuration.model.guardian_dob_pretty = this.model.guardian_dob_pretty
        this.configuration.model.guardianLastName = this.model.guardianLastName
        this.configuration.model.guardianFirstName = this.model.guardianFirstName
        this.configuration.model.gender = this.model.gender
        this.configuration.model.race = this.model.race
        this.configuration.model.ethnicity = this.model.ethnicity
        this.$store.state.dataForInsurance.dob = this.model.dob
        this.$store.state.dataForInsurance.dob_pretty = this.model.dob_pretty
        this.$store.state.dataForInsurance.gender = this.model.gender
        return true
      }
      return false
    }
  },
  computed: {
    ...mapFields(['gender', 'race', 'ethnicity', 'dob', 'guardianFirstName', 'guardianLastName'])
  },
  watch: {
    'model.guardianFirstName': {
      handler: function (after, before) {
        if (this.$store.state.configs.ENABLE_GUARDIAN_INFO && this.guardian_info) {
          this.configuration.model.guardianFirstName = this.model.guardianFirstName
          if (this.modelValidations.guardianFirstName.required) {
            if (this.model.guardianFirstName.length > this.modelValidations.guardianFirstName.min - 1) {
              this.geneticsSectionValidation.guardianFirstNameValidation = true
            } else {
              this.geneticsSectionValidation.guardianFirstNameValidation = false
            }
          } else {
            this.geneticsSectionValidation.guardianFirstNameValidation = true
          }
        }
      }
    },
    'model.guardianLastName': {
      handler: function (after, before) {
        if (this.$store.state.configs.ENABLE_GUARDIAN_INFO && this.guardian_info) {
          this.configuration.model.guardianLastName = this.model.guardianLastName
          if (this.modelValidations.guardianLastName.required) {
            if (this.model.guardianLastName.length > this.modelValidations.guardianLastName.min - 1) {
              this.geneticsSectionValidation.guardianLastNameValidation = true
            } else {
              this.geneticsSectionValidation.guardianLastNameValidation = false
            }
          } else {
            this.geneticsSectionValidation.guardianLastNameValidation = true
          }
        }
      }
    },
    'model.gender': {
      handler: function (after, before) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true) {
          this.$store.state.insuranceData.gender = this.model.gender
        }
        if (this.type === 'Registration') {
          this.$store.state.insuranceData.gender = this.model.gender
        }
        if (this.$store.state.relationship === 'Self') {
          let dummyData = {
            gender: this.model.gender,
            dob: this.model.dob,
            dob_pretty: this.model.dob_pretty
          }
          this.$store.state.geneticsComponentInsuranceData = dummyData
        }
        this.configuration.model.gender = this.model.gender
        if (this.modelValidations.gender.required) {
          if (this.model.gender) {
            this.geneticsSectionValidation.genderValidation = true
          } else {
            this.geneticsSectionValidation.genderValidation = false
          }
        } else {
          this.geneticsSectionValidation.genderValidation = true
        }
      },
      deep: true
    },
    'model.race': {
      handler: function (after, before) {
        this.configuration.model.race = this.model.race
        if (this.modelValidations.race.required) {
          if (this.model.race) {
            this.geneticsSectionValidation.raceValidation = true
          } else {
            this.geneticsSectionValidation.raceValidation = false
          }
        } else {
          this.geneticsSectionValidation.raceValidation = true
        }
      }
    },
    'model.ethnicity': {
      handler: function (after, before) {
        this.configuration.model.ethnicity = this.model.ethnicity
        if (this.modelValidations.ethnicity.required) {
          if (this.model.ethnicity) {
            this.geneticsSectionValidation.ethnicityValidation = true
          } else {
            this.geneticsSectionValidation.ethnicityValidation = false
          }
        } else {
          this.geneticsSectionValidation.ethnicityValidation = true
        }
      }
    },
    'model.dob_pretty': {
      handler: function (dobValue) {
        if (this.$store.state.userData['dob_scanned']) {
          if (dobValue.length === 8) {
            this.model.dob_pretty = dobValue.substring(0, 2) + '/' + dobValue.substring(2, 4) + '/' + dobValue.substring(4, 8)
            this.model.dob = dobValue.substring(0, 2) + '/' + dobValue.substring(2, 4) + '/' + dobValue.substring(4, 8)
            this.configuration.model.dob_pretty = this.model.dob_pretty
            this.configuration.model.dob = this.model.dob
          }
        } else {
          let dateCleave = new Cleave('.date-cleave-format', {
            date: true,
            delimiter: '/',
            datePattern: ['m', 'd', 'Y']
          })
          this.model.dob_pretty = dateCleave.getFormattedValue()
          this.model.dob = dateCleave.getFormattedValue()
          this.configuration.model.dob_pretty = this.model.dob_pretty
          this.configuration.model.dob = this.model.dob
          if (dobValue.length === 10) {
            let date1 = new Date(this.model.dob_pretty)
            var ageDifMs = Date.now() - date1
            var ageDate = new Date(ageDifMs)
            let ages = (Math.abs(ageDate.getUTCFullYear() - 1970))
            if (this.$store.state.configs.ENABLE_GUARDIAN_INFO) {
              if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === false) {
                if (ages < 18) {
                  this.guardian_info = true
                  if (this.type === 'personalData') {
                    this.guardian_info = false
                    this.error_date = 'The age must not be less than 18'
                    this.geneticsSectionValidation.dobValidation = false
                  } else if (this.type !== undefined) {
                    this.model.guardianFirstName = this.$store.state.patientRegistrationData['first_name'] ? this.$store.state.patientRegistrationData['first_name'] : this.$store.state.patientRegistrationData['firstName']
                    this.model.guardianLastName = this.$store.state.patientRegistrationData['last_name'] ? this.$store.state.patientRegistrationData['last_name'] : this.$store.state.patientRegistrationData['lastName']
                    this.model.guardian_dob = this.$store.state.patientRegistrationData['date_of_birth'] ? this.$store.state.patientRegistrationData['date_of_birth'] : this.$store.state.patientRegistrationData['dob']
                    this.model.guardian_dob_pretty = this.model.guardian_dob.substring(5, 7) + '/' + this.model.guardian_dob.substring(8, 10) + '/' + this.model.guardian_dob.substring(0, 4)
                  }
                  if (this.type === undefined) {
                    this.model.guardianFirstName = ''
                    this.model.guardianLastName = ''
                    this.model.guardian_dob = ''
                    this.model.guardian_dob_pretty = ''
                    this.geneticsSectionValidation.guardianDobValidation = false
                    this.geneticsSectionValidation.guardianFirstNameValidation = false
                    this.geneticsSectionValidation.guardianLastNameValidation = false
                  }
                } else {
                  this.guardian_info = false
                  this.guardian_first_name = ''
                  this.guardian_last_name = ''
                  this.geneticsSectionValidation.guardianFirstNameValidation = true
                  this.geneticsSectionValidation.guardianLastNameValidation = true
                  this.geneticsSectionValidation.guardianDobValidation = true
                  this.error_date = ''
                }
              } else {
                if (ages < 18) {
                  this.guardian_info = true
                  if (this.type === 'personalData' || (this.type === 'Registration' && this.$store.state.dependentSelected === false)) {
                    this.guardian_info = false
                    this.error_date = 'The age must not be less than 18'
                    this.geneticsSectionValidation.dobValidation = false
                  } else if (this.type !== undefined) {
                    this.guardian_info = true
                    this.model.guardianFirstName = this.$store.state.patientRegistrationData['first_name'] ? this.$store.state.patientRegistrationData['first_name'] : this.$store.state.patientRegistrationData['firstName']
                    this.model.guardianLastName = this.$store.state.patientRegistrationData['last_name'] ? this.$store.state.patientRegistrationData['last_name'] : this.$store.state.patientRegistrationData['lastName']
                    this.model.guardian_dob = this.$store.state.patientRegistrationData['date_of_birth'] ? this.$store.state.patientRegistrationData['date_of_birth'] : this.$store.state.patientRegistrationData['dob']
                    this.model.guardian_dob_pretty = this.model.guardian_dob.substring(5, 7) + '/' + this.model.guardian_dob.substring(8, 10) + '/' + this.model.guardian_dob.substring(0, 4)
                  }
                  if (this.type === undefined) {
                    this.model.guardianFirstName = ''
                    this.model.guardianLastName = ''
                    this.model.guardian_dob = ''
                    this.model.guardian_dob_pretty = ''
                    this.geneticsSectionValidation.guardianDobValidation = false
                    this.geneticsSectionValidation.guardianFirstNameValidation = false
                    this.geneticsSectionValidation.guardianLastNameValidation = false
                  }
                } else {
                  this.guardian_info = false
                  this.model.guardian_first_name = ''
                  this.model.guardian_last_name = ''
                  this.model.guardian_dob = ''
                  this.model.guardian_dob_pretty = ''
                  this.geneticsSectionValidation.guardianFirstNameValidation = true
                  this.geneticsSectionValidation.guardianLastNameValidation = true
                  this.geneticsSectionValidation.guardianDobValidation = true
                  this.error_date = ''
                }
                this.$store.state.insuranceData.dob = this.model.dob
                this.$store.state.insuranceData.dob_pretty = this.model.dob_pretty
              }
            } else {
              this.geneticsSectionValidation.dobValidation = true
              if (ages < 18) {
                this.error_date = 'The age must not be less than 18'
                this.geneticsSectionValidation.dobValidation = false
              } else {
                this.error_date = ''
                this.geneticsSectionValidation.dobValidation = true
              }
            }
            let dateParts = dobValue.split('/')
            this.model.dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
            this.$store.state.insuranceData.dob = this.model.dob
            this.$store.state.insuranceData.dob_pretty = this.model.dob_pretty
          }
          if (this.$store.state.relationship === 'Self') {
            let dummyData = {
              gender: this.model.gender,
              dob: this.model.dob,
              dob_pretty: this.model.dob_pretty
            }
            this.$store.state.geneticsComponentInsuranceData = dummyData
          }
          if (dobValue.length === 0) {
            this.$store.state.insuranceData.dob = this.model.dob
            this.$store.state.insuranceData.dob_pretty = this.model.dob_pretty
          }
          if (this.type === 'Registration') {
            this.$store.state.insuranceData.dob = this.model.dob
            this.$store.state.insuranceData.dob_pretty = this.model.dob_pretty
          }
        }
        if (!this.model.dob) {
          this.geneticsSectionValidation.dobValidation = false
        } else if (this.isFutureDate(this.model.dob_pretty)) {
          this.geneticsSectionValidation.dobValidation = false
        } else if (this.isOldDate(this.model.dob_pretty)) {
          this.geneticsSectionValidation.dobValidation = false
        } else if (this.error_date !== '') {
          this.geneticsSectionValidation.dobValidation = false
        } else if (this.model.dob.length === 10) {
          this.geneticsSectionValidation.dobValidation = true
        }
      },
      deep: true
    },
    'model.guardian_dob_pretty': {
      handler: function (dobValue) {
        if (this.$store.state.configs.ENABLE_GUARDIAN_INFO && this.guardian_info) {
          if (dobValue.length !== 10) {
            let dateCleave = new Cleave('.date-cleave-format1', {
              date: true,
              delimiter: '/',
              datePattern: ['m', 'd', 'Y']
            })
            this.model.guardian_dob_pretty = dateCleave.getFormattedValue()
            this.configuration.model.guardian_dob_pretty = this.model.guardian_dob_pretty
          }
          if (dobValue.length === 10) {
            let dateParts = dobValue.split('/')
            this.model.guardian_dob = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
            this.configuration.model.guardian_dob = this.model.guardian_dob
          }
          if (this.model.guardian_dob_pretty.length < 10) {
            this.geneticsSectionValidation.guardianDobValidation = false
          } else if (this.isFutureDate(this.model.guardian_dob_pretty)) {
            this.geneticsSectionValidation.guardianDobValidation = false
          } else if (this.isOldDate(this.model.guardian_dob_pretty)) {
            this.geneticsSectionValidation.guardianDobValidation = false
          } else {
            this.geneticsSectionValidation.guardianDobValidation = true
          }
        }
      },
      deep: true
    },
    '$store.state.requirements': {
      handler: function (after, before) {
        this.modelValidations.gender.required = this.checkRequirement('gender')
        this.modelValidations.race.required = this.checkRequirement('race')
        this.modelValidations.ethnicity.required = this.checkRequirement('ethnicity')

        this.geneticsSectionValidation = {
          genderValidation: !this.checkRequirement('gender'),
          raceValidation: !this.checkRequirement('race'),
          ethnicityValidation: !this.checkRequirement('ethnicity'),
          dobValidation: false,
          guardianFirstNameValidation: true,
          guardianLastNameValidation: true,
          guardianDobValidation: true
        }
        this.$watch('geneticsSectionValidation', this.computeGeneticsValidationObject, {deep: true})
      },
      deep: true
    },
    '$store.state.relationship': {
      handler: function (after, before) {
        if (this.$store.state.relationship === 'Self') {
          let dummyData = {
            gender: this.model.gender,
            dob: this.model.dob,
            dob_pretty: this.model.dob_pretty
          }
          this.$store.state.geneticsComponentInsuranceData = dummyData
        }
      }
    },
    '$store.state.userData.gender': {
      handler (value) {
        this.model.gender = value
      }
    },
    '$store.state.userData.dob': {
      handler (value) {
        this.model.dob = value
      }
    },
    '$store.state.userData.dob_pretty': {
      handler (value) {
        this.model.dob_pretty = value
      }
    },
    'triggerGeneticsWatch': {
      handler: function (after, before) {
        this.$watch('geneticsSectionValidation', this.computeGeneticsValidationObject, {deep: true})
      }
    }
  },
  mounted () {
    if (this.triggerGeneticsWatch === true) {
      this.$watch('geneticsSectionValidation', this.computeGeneticsValidationObject, {deep: true})
    }
  },
  beforeMount () {
    let token = localStorage.getItem('token')
    if (token) {
      this.model.dob = this.$store.state.userData['dob'] || ''
      this.model.dob_pretty = this.$store.state.userData['dob_pretty'] || ''
      this.model.gender = this.$store.state.userData['gender'] || ''
      this.model.race = this.$store.state.userData['race'] || ''
      this.model.ethnicity = this.$store.state.userData['ethnicity'] || ''
      if (this.model.dob_pretty) {
        if (this.model.dob_pretty.length === 10) {
          this.model.dob_pretty = this.$store.state.userData.dob_pretty.substring(5, 7) + '/' + this.$store.state.userData.dob_pretty.substring(8, 10) + '/' + this.$store.state.userData.dob_pretty.substring(0, 4)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/sass/paper/_variables.scss";

  .gender-float{
    text-align: right;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }
  @media screen and (max-width: 991px) {
  .gender-float{
    text-align: left;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/GeneticsSection.vue